let downloads = {

    init: () =>{

        downloads.name =  '.downloads';
        downloads.elements = document.querySelectorAll(downloads.name);
        downloads.attemptActionIfNotEmpty(downloads.ready);

        window.addEventListener('load', () => {
            downloads.attemptActionIfNotEmpty(downloads.loaded);
        });

        return downloads;
    },

    attemptActionIfNotEmpty: function (action) {
        if (downloads.elements.length > 0) {
            action();
        }
    },

    ready : () => {

    },

    loaded : () => {

    }

};

export default downloads.init();
